import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Typography } from "@mui/material";
import Autocomplete from "@mui/material/Autocomplete";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { debounce } from "underscore";
import { dnbGetCookie, isNotUndefinedOrNull, sitePreferenceCookieName } from "../FunctionsCore";
const DEBOUNCE = 500;
const EMPTY_SEARCH_TERM = "";
const EMPTY_OPTIONS = [];
const MIN_SEARCH_TERM_CHARS = 3;
const CompanyAutoComplete = (props) => {
    var _a, _b;
    const { countryCode, onCompanyChange, placeholder, popupBeforeInputSearchMinCharactersRequirement, popupOptionNoResultsWereFound, popupURLNoResultsWereFound } = props;
    const [isOpen, setIsOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState(EMPTY_SEARCH_TERM);
    const [data, setData] = useState(EMPTY_OPTIONS);
    const [isLoading, setIsLoading] = useState(false);
    const inputRef = useRef(null);
    const sitePreferenceCookieValue = dnbGetCookie(sitePreferenceCookieName);
    useEffect(() => {
        const getData = (term) => {
            setIsLoading(true);
            axios.get("/apps/dnb/servlets/TypeaheadSearchServlet", {
                "params": {
                    "countryCode": countryCode,
                    "includeAddress": "true",
                    "includeCompanyInfoCookie": "true",
                    "searchTerm": term,
                    "sitePreferenceCookieValue": sitePreferenceCookieValue
                },
            }).then(res => {
                if (isNotUndefinedOrNull(res)) {
                    setData(res.data.companies);
                }
            }).finally(() => setIsLoading(false));
        };
        if (searchTerm !== "") {
            getData(searchTerm);
        }
    }, [countryCode, searchTerm, sitePreferenceCookieValue]);
    const debouncedSearchTerm = debounce(value => setSearchTerm(value), DEBOUNCE);
    const onSearch = (value) => {
        if (value.length >= MIN_SEARCH_TERM_CHARS) {
            debouncedSearchTerm(value);
            return;
        }
        setData(EMPTY_OPTIONS);
        setSearchTerm(EMPTY_SEARCH_TERM);
        debouncedSearchTerm.cancel();
    };
    const options = isOpen ? data : [];
    return (_jsx(Autocomplete, { filterOptions: (option) => option, getOptionLabel: (option) => option.primaryName, loading: isLoading, noOptionsText: ((_b = (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.value.length) !== null && _b !== void 0 ? _b : 0) < MIN_SEARCH_TERM_CHARS ? popupBeforeInputSearchMinCharactersRequirement : _jsx("a", Object.assign({ href: popupURLNoResultsWereFound }, { children: popupOptionNoResultsWereFound })), onChange: (sy, co) => {
            sy.preventDefault();
            onCompanyChange(co !== null && co !== void 0 ? co : void 0);
        }, onClose: () => {
            setIsOpen(false);
        }, onOpen: () => {
            setIsOpen(true);
        }, open: isOpen, options: options, renderInput: (params) => (_jsx(TextField, Object.assign({}, params, { InputProps: Object.assign(Object.assign({}, params.InputProps), { "endAdornment": (_jsxs(_Fragment, { children: [isLoading
                            ? _jsx(CircularProgress, { color: "inherit", size: 20 })
                            : _jsx(_Fragment, {}), params.InputProps.endAdornment] })) }), inputRef: inputRef, onChange: (e) => onSearch(e.target.value), placeholder: placeholder, sx: { "background": (theme) => theme.palette.common.white, "borderRadius": "8px" } }))), renderOption: (renderProps, option) => (_jsxs(Box, Object.assign({ component: "li" }, renderProps, { sx: { "display": "flex", "justifyContent": "space-between !important", "width": "100%" } }, { children: [_jsx(Typography, Object.assign({ gutterBottom: true }, { children: option.primaryName })), _jsxs(Box, Object.assign({ sx: { "display": "flex", "flexDirection": "column", "textAlign": "right" } }, { children: [_jsx(Typography, Object.assign({ gutterBottom: true, variant: "body2" }, { children: option.companyCity })), _jsx(Typography, Object.assign({ gutterBottom: true, variant: "caption" }, { children: option.companyAddress }))] }))] }))) }));
};
export { CompanyAutoComplete };
